import DeleteIcon from '@mui/icons-material/Delete';

export default DeleteIcon;
